@let view = data();

<div class="content-wrap">
  <div class="media">
    @if (hasPlaybackError() && view.fallbackImage) {
      <ui-image [data]="view.fallbackImage"></ui-image>
    } @else if (view.video.src; as src) {
      <ui-video-content-player
        class="hero-video-player"
        aspectRatio="auto"
        [src]="src"
        [controls]="false"
        [autoplay]="true"
        [loop]="true"
        (playbackError)="handlePlaybackError()"
      ></ui-video-content-player>
    } @else if (view.fallbackImage) {
      <ui-image [data]="view.fallbackImage"></ui-image>
    }
  </div>

  <div class="text">
    @if (view.headlines.headline || view.headlines.subline) {
      <ui-headlines [data]="view.headlines"></ui-headlines>
    }

    @if (view.content) {
      <div [innerHtml]="view.content" class="rte rte-themed" uiHtmlDataLink></div>
    }
  </div>
</div>
